import { render, staticRenderFns } from "./BetInAcceptanceInCart.vue?vue&type=template&id=84295e90&scoped=true"
import script from "./BetInAcceptanceInCart.vue?vue&type=script&lang=js"
export * from "./BetInAcceptanceInCart.vue?vue&type=script&lang=js"
import style0 from "./BetInAcceptanceInCart.vue?vue&type=style&index=0&id=84295e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84295e90",
  null
  
)

export default component.exports